import FROM_GALLERY_PAGE_REQUEST from '../actionTypes/FromGalleryActionTypes';

const fromGallery = (payload) => ({
    type: FROM_GALLERY_PAGE_REQUEST,
    payload,
});

export default fromGallery;
